import { Button, Text } from 'components'
import { FormItem, FormLabel, Select } from 'components/Form'
import Modal from 'components/ModalV2'
import { useForm } from 'react-hook-form'

import styles from './styles.module.scss'
import { useFindAllPatrimonies } from 'services/patrimony'

import { capitalize } from 'utilities/capitalize'
import { useGetPatrimonyAccounts } from 'services/account'
import { parseCookies } from 'nookies'

import { useSearchParams } from 'react-router-dom'

interface ChangeAccount {
  isVisible: boolean
  onClose: () => void
}

type Form = {
  patrimony: {
    id: string
    name: string
  }
  account?: {
    id: string
    name: string
  }
}

const ChangeAccount = ({ isVisible, onClose }: ChangeAccount) => {
  const { userId } = parseCookies() || ''

  const [searchParams, setSearchParams] = useSearchParams()

  const { setValue, watch, handleSubmit } = useForm<Form>()

  const { patrimony, account } = watch()

  const { data: patrimonies } = useFindAllPatrimonies(userId || '')

  const { data: accounts } = useGetPatrimonyAccounts(patrimony?.id || '')

  const handleOnSubmit = () => {
    localStorage.setItem('accountId', account?.id || '')

    setSearchParams({
      ...Object.fromEntries([...searchParams]),
      page: '1',
    })

    onClose()
  }

  return (
    <Modal.Root isOpen={isVisible} onClose={onClose}>
      <Modal.Content size="sm">
        <Modal.Title>Selecionar patrimônio</Modal.Title>
        <form className={styles.form} onSubmit={handleSubmit(handleOnSubmit)}>
          <div className={styles.content}>
            <Text weight="regular">
              Selecione um patrimônio para visualizar seus eventos, plano de
              ação, usuários e consultar equipamentos.
            </Text>

            <FormItem>
              <FormLabel htmlFor="patrimony">Patrimônio</FormLabel>
              <Select.Root valueKey="name" data={patrimonies || []}>
                {({ unSelectedOptions }) => (
                  <>
                    <Select.Field
                      id="patrimony"
                      placeholder="Selecione o patrimônio"
                      value={patrimony?.name}
                    />
                    <Select.Group>
                      {unSelectedOptions?.map((patrimony) => {
                        const fullAddress = `${patrimony.address.address}, ${patrimony.address.number}, ${capitalize(patrimony.address.district)}, ${capitalize(patrimony.address.city)}/${patrimony.address.acronym}`

                        return (
                          <Select.Option
                            key={patrimony.id}
                            className={styles.options}
                            onClick={() => {
                              setValue(
                                'patrimony',
                                {
                                  id: patrimony.id,
                                  name: fullAddress,
                                },
                                {
                                  shouldValidate: true,
                                },
                              )

                              setValue('account', undefined, {
                                shouldValidate: true,
                              })
                            }}
                          >
                            {fullAddress}
                          </Select.Option>
                        )
                      })}
                    </Select.Group>
                  </>
                )}
              </Select.Root>
            </FormItem>

            <FormItem>
              <FormLabel htmlFor="account">Conta</FormLabel>
              <Select.Root valueKey="name" data={accounts?.data || []}>
                {({ unSelectedOptions }) => (
                  <>
                    <Select.Field
                      id="account"
                      placeholder="Selecione a conta"
                      value={account?.name}
                    />
                    <Select.Group>
                      {unSelectedOptions?.map((account) => {
                        const name = `${account.code} [${account.serviceType}] ${account.name}`

                        return (
                          <Select.Option
                            key={account.id}
                            onClick={() => {
                              setValue(
                                'account',
                                {
                                  id: account.id,
                                  name: account.name,
                                },
                                {
                                  shouldValidate: true,
                                },
                              )
                            }}
                          >
                            {name}
                          </Select.Option>
                        )
                      })}
                    </Select.Group>
                  </>
                )}
              </Select.Root>
            </FormItem>
          </div>

          <Modal.Footer>
            <Modal.Close asChild>
              <Button type="button" appearance="tertiary">
                Cancelar
              </Button>
            </Modal.Close>
            <Button width={124} type="submit">
              Continuar
            </Button>
          </Modal.Footer>
        </form>
      </Modal.Content>
    </Modal.Root>
  )
}

export default ChangeAccount
